/* Shared cart-add helpers — extracted from assets/rude-gift-picker.js so
   multiple pickers (gift picker, Trial Hero inline picker) can reuse the
   same proven AJAX + cart-drawer flow without duplicating logic.

   Exposes window.RudeCartAdd = { setLoading, openCartDrawer, addItems }.

   Why not just import this file as a module: Halo's theme is jQuery + IIFE
   so we keep the same shape (loaded as a plain <script defer>). The
   loaders attach the global synchronously, so callers can reference it
   from inside event handlers (i.e. lazily — load order between this file
   and its consumers doesn't matter for click-time use, but we still load
   this one first in layout/theme.liquid for clarity).

   See the comment block at the top of rude-gift-picker.js for the full
   context on why we need an XHR-based multi-item /cart/add.js path that
   bypasses the fetch monkeypatch in the main bundle.
*/

(function () {
  if (window.RudeCartAdd) return;

  function setLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }
  }

  function openCartDrawer() {
    // Re-implementation of the parts of Halo's halo.updateSidebarCart we
    // need (halo lives inside theme.js's IIFE and is not on window). We
    // fetch /cart?view=ajax_side_cart, inject the rendered HTML into the
    // sidebar wrapper, then reveal the drawer. Critical: we reveal AFTER
    // the AJAX completes (not before) — see the long comment in the
    // original implementation in rude-gift-picker.js git history for why.
    var $ = window.jQuery || window.$;
    if (
      !$ ||
      typeof window.Shopify !== 'object' ||
      typeof window.Shopify.getCart !== 'function'
    ) {
      window.location.reload();
      return;
    }
    window.Shopify.getCart(function (cart) {
      var $cartDropdown = $(
        '#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper'
      );
      if ($cartDropdown.length === 0) {
        window.location.reload();
        return;
      }
      var loadingClass = 'is-loading';
      var $cartLoading = $(
        '<div class="loading-overlay loading-overlay--custom">' +
          '<div class="loading-overlay__spinner">' +
            '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
              '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
            '</svg>' +
          '</div>' +
        '</div>'
      );
      $cartDropdown.addClass(loadingClass).prepend($cartLoading);
      var routesRoot = (window.routes && window.routes.root) || '/';
      $.ajax({
        type: 'GET',
        url: routesRoot + 'cart?view=ajax_side_cart',
        cache: false,
        success: function (data) {
          $cartDropdown.removeClass(loadingClass).html($(data));
          document.body.classList.add('cart-sidebar-show');
        },
        error: function () {
          $cartDropdown.removeClass(loadingClass);
          document.body.classList.add('cart-sidebar-show');
        },
        complete: function () {
          $('body').find('[data-cart-count]').text(cart.item_count);
          if (cart.item_count >= 100 && window.cartStrings) {
            $('body')
              .find('.cart-count-bubble [data-cart-count]')
              .text(window.cartStrings.item_99);
          }
          if (window.cartStrings) {
            $('body')
              .find('[data-cart-text]')
              .text(
                cart.item_count == 1
                  ? window.cartStrings.item
                  : window.cartStrings.items
              );
          }
          document.dispatchEvent(
            new CustomEvent('cart-update', { detail: cart })
          );
        }
      });
    });
  }

  function addItems(items, btn, onSuccess, onError) {
    setLoading(btn, true);
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onload = function () {
      setLoading(btn, false);
      if (xhr.status >= 200 && xhr.status < 300) {
        if (typeof onSuccess === 'function') onSuccess(xhr);
      } else {
        if (typeof onError === 'function') {
          onError(xhr);
        } else {
          console.error('rude-cart-add: cart/add failed', xhr.status, xhr.responseText);
        }
      }
    };
    xhr.onerror = function () {
      setLoading(btn, false);
      if (typeof onError === 'function') {
        onError(xhr);
      } else {
        console.error('rude-cart-add: cart/add XHR error');
      }
    };
    xhr.send(JSON.stringify({ items: items }));
  }

  window.RudeCartAdd = {
    setLoading: setLoading,
    openCartDrawer: openCartDrawer,
    addItems: addItems
  };
})();
